// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__q8uIs","icon":"SortAdornment_icon__2SzAJ","up":"SortAdornment_up__2mD6B","down":"SortAdornment_down__1hxPE","active":"SortAdornment_active__KRUFs"};